module.exports = __webpack_public_path__ + "static/media/dashboard1.54f4e875.png";